var _ellipse, _path, _path2, _path3, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCasualconversationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 42,
    viewBox: "0 0 37 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.1992,
    cy: 4.02037,
    rx: 3.99611,
    ry: 4.02037,
    fill: "#0071C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9161 16.3382C24.9161 16.3382 24.9161 15.3117 24.9161 14.1142C24.9161 13.4299 24.7461 12.7455 24.406 12.1468C23.3007 10.2649 20.92 9.58057 18.1993 9.58057C15.4785 9.58057 13.0979 10.3504 11.9926 12.1468C11.6525 12.7455 11.4824 13.4299 11.4824 14.1142C11.4824 15.2262 11.4824 16.3382 11.4824 16.3382H24.9161Z",
    fill: "#0071C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1191 39.434H1.27977C0.429532 39.434 -0.250656 38.5786 0.0894381 37.7232L7.57151 16.5949C7.82658 15.9106 8.42175 15.4829 9.18696 15.4829H27.212C27.8921 15.4829 28.5723 15.9106 28.8274 16.5949L36.3095 37.7232C36.5645 38.5786 35.9694 39.434 35.1191 39.434Z",
    fill: "#E1EAF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4337 41.9998C24.4337 41.9998 24.4337 40.9733 24.4337 39.7758C24.4337 39.0915 24.2637 38.4072 23.9236 37.8084C22.8183 35.9265 20.4376 35.2422 17.7169 35.2422C14.9961 35.2422 12.6154 36.012 11.5101 37.8084C11.17 38.4072 11 39.0915 11 39.7758C11 40.8878 11 41.9998 11 41.9998H24.4337Z",
    fill: "#FF4662"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.7168,
    cy: 29.6825,
    rx: 3.99611,
    ry: 4.02037,
    fill: "#FF4662"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasualconversationIcon);
export default __webpack_public_path__ + "static/media/CasualconversationIcon.0ad00b44444bc59b4008082a1852bf13.svg";
export { ForwardRef as ReactComponent };